import styles from './PaymentsComparisonModalBody.module.scss';

import Grid from '@material-ui/core/Grid';
import React from 'react';

import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { PaymentOptions } from 'components/PaymentsComparisonLink/PaymentsComparisonModal/PaymentsComparisonModal';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { PaymentOptionItem } from './PaymentOptionItem/PaymentOptionItem';

interface IPaymentOptionItemsMobileProps {
  headingItems: FlatEntry<Subject>[];
  items: FlatEntry<Subject>[];
}

const PaymentOptionItemsMobile: React.FC<IPaymentOptionItemsMobileProps> = ({ headingItems, items }) => {
  return (
    <div className={styles.items}>
      {headingItems &&
        headingItems.map((item, index) => {
          const optionSideHeading = headingItems[index] || null;
          const optionItem = items[index] || null;
          return (
            <div className={styles.itemsDisplay} key={componentKeyV2(item, index)}>
              <Grid container>
                <Grid xs={4} className={styles.itemsRightBorder}>
                  <PaymentOptionItem item={optionSideHeading?.blurb} variantType="body-medium" />
                </Grid>
                <Grid xs={8}>
                  <PaymentOptionItem item={optionItem?.blurb} />
                </Grid>
              </Grid>
            </div>
          );
        })}
    </div>
  );
};

interface IMobilePaymentsComparisonModalBodyProps {
  activePaymentOption: PaymentOptions;
  sideHeadingOptionItems: FlatEntry<Subject>[];
  monthlyOptionItems: FlatEntry<Subject>[];
  upfrontOptionItems: FlatEntry<Subject>[];
}

const MobilePaymentsComparisonModalBody: React.FC<IMobilePaymentsComparisonModalBodyProps> = ({
  activePaymentOption,
  sideHeadingOptionItems,
  monthlyOptionItems,
  upfrontOptionItems,
}) => {
  return (
    <>
      {activePaymentOption === PaymentOptions.MONTHLY && (
        <PaymentOptionItemsMobile headingItems={sideHeadingOptionItems} items={monthlyOptionItems} />
      )}
      {activePaymentOption === PaymentOptions.UPFRONT && (
        <PaymentOptionItemsMobile headingItems={sideHeadingOptionItems} items={upfrontOptionItems} />
      )}
    </>
  );
};

interface IDesktopPaymentsComparisonModalBodyProps {
  sideHeadingOptionItems: FlatEntry<Subject>[];
  monthlyOptionItems: FlatEntry<Subject>[];
  upfrontOptionItems: FlatEntry<Subject>[];
}

const DesktopPaymentsComparisonModalBody: React.FC<IDesktopPaymentsComparisonModalBodyProps> = ({
  sideHeadingOptionItems,
  monthlyOptionItems,
  upfrontOptionItems,
}) => {
  return (
    <div className={styles.items}>
      {sideHeadingOptionItems.map((item, index) => {
        const itemSideHeading = sideHeadingOptionItems[index] || null;
        const monthlyItem = monthlyOptionItems[index] || null;
        const upfrontItem = upfrontOptionItems[index] || null;
        return (
          <div className={styles.itemsDisplay} key={componentKeyV2(item, index)}>
            <Grid container>
              <Grid lg={2} className={styles.itemsRightBorder}>
                <PaymentOptionItem item={itemSideHeading?.blurb} variantType="body-medium" />
              </Grid>
              <Grid lg={5} className={styles.itemsRightBorder}>
                <PaymentOptionItem item={monthlyItem?.blurb} />
              </Grid>
              <Grid lg={5}>
                <PaymentOptionItem item={upfrontItem?.blurb} />
              </Grid>
            </Grid>
          </div>
        );
      })}
    </div>
  );
};

interface IPaymentsComparisonModalBodyProps {
  activePaymentOption: PaymentOptions;
  sideHeadingOptionItems?: FlatEntry<Subject>[];
  monthlyOptionItems: FlatEntry<Subject>[];
  upfrontOptionItems: FlatEntry<Subject>[];
  isFullWidth?: boolean;
}

export const PaymentsComparisonModalBody: React.FC<IPaymentsComparisonModalBodyProps> = ({
  activePaymentOption,
  sideHeadingOptionItems,
  monthlyOptionItems,
  upfrontOptionItems,
  isFullWidth,
}) => {
  if (!monthlyOptionItems.length || !upfrontOptionItems.length || !sideHeadingOptionItems?.length)
    return null;

  return isFullWidth ? (
    <MobilePaymentsComparisonModalBody
      activePaymentOption={activePaymentOption}
      sideHeadingOptionItems={sideHeadingOptionItems}
      monthlyOptionItems={monthlyOptionItems}
      upfrontOptionItems={upfrontOptionItems}
    />
  ) : (
    <DesktopPaymentsComparisonModalBody
      sideHeadingOptionItems={sideHeadingOptionItems}
      monthlyOptionItems={monthlyOptionItems}
      upfrontOptionItems={upfrontOptionItems}
    />
  );
};
